// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.baloa-play-payment-options-modal .modal__container {
    width: 715px;
    padding: 55px 44px 24px 44px;
}   

.baloa-play-payment-options-modal__container {
    text-align: center;
}

.baloa-play-payment-options-modal .modal__container__close {
    right: 20px;
    top: 14px;
}

.baloa-play-payment-options-modal .modal__container__close img {
    width: 16px;
    height: 16px;
}

.baloa-play-payment-options-modal__title {
    font-family: "Lexend Deca";
    font-size: 20px;
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
    margin-top: 6px;
}

.baloa-play-payment-options-modal__message-container {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    margin-top: 0;
}

.baloa-play-payment-options-modal__message-container .hubicon-award_star {
    font-size: 24px;
}

/* .baloa-play-payment-options-modal__subtitle {
    font-family: "Lexend Deca";
    font-size: 18px;
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
    margin-top: 6px;
} */

.baloa-play-payment-options-modal__message {
    font-family: "Lexend Deca";
    font-size: 17px;
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
    margin-top: 14px;
}

.baloa-play-payment-options-modal__message-container .primary-button.button {
    width: 100%;
    margin-top: 10px;
    font-size: 18px;
    text-transform: unset;
    font-family: "Lexend Deca";
}

.baloa-play-payment-options-modal__message-container .primary-button.button span {
    text-transform: unset;
}

.baloa-play-payment-options-modal__container .button {
    width: 100%;
    padding: 12px;
    margin-top: 36px;
    text-transform: unset;
    font-size: 18px;
}

.baloa-play-payment-options-modal__container .button.primary-button {
    margin-top: 10px;
}

.baloa-play-payment-options-modal__container .secondary-button.button span {
    text-transform: unset;
}

.baloa-play-payment-options-modal__comparative-title {
    font-family: "Lexend Deca";
    font-size: 18px;
    margin-top: 14px;
    font-weight: var(--font-medium);
    color: var(--black-color);
    padding: 10px 0;
    border-top: 1px solid var(--new-gray-background-color);
    border-bottom: 1px solid var(--new-gray-background-color);
    display: flex;
    align-items: center;
}

.baloa-play-payment-options-modal__comparative-title .option {
    padding: 10px;
    text-align: left;
    width: 60%;
}

.baloa-play-payment-options-modal__comparative-title .no-pro {
    padding: 10px 0;
    text-align: center;
    font-weight: var(--font-regular);
    width: 20%;
}

.baloa-play-payment-options-modal__comparative-title .pro {
    padding: 10px 0;
    justify-content: center;
    font-weight: 700;
    display: flex;
    align-items: center;
    width: 20%;
}

.baloa-play-payment-options-modal__comparative-char {
    font-family: "Lexend Deca";
    font-size: 16px;
    font-weight: var(--font-regular);
    color: var(--primary-very-dark-color);
    padding: 11px 0;
    border-bottom: 1px solid var(--new-gray-background-color);
    display: flex;
    align-items: center;
}

.baloa-play-payment-options-modal__comparative-char:last-child {
    border-bottom: none;
}

.baloa-play-payment-options-modal__comparative-char .option {
    padding: 10px;
    text-align: left;
    width: 60%;
}

.baloa-play-payment-options-modal__comparative-char .mark {
    padding: 10px 0;
    text-align: center;
    width: 20%;
}

.baloa-play-payment-options-modal__comparative-char .mark .hubicon-clear_option {
    color: var(--error-color);
    font-size: 24px;
}

.baloa-play-payment-options-modal__comparative-char .mark .hubicon-check {
    color: var(--new-green-color);
    font-size: 24px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .baloa-play-payment-options-modal.modal {
        top: unset;
    }

    .baloa-play-payment-options-modal .modal__container__close {
        right: 12px;
    }

    .baloa-play-payment-options-modal .modal__container__close img {
        width: 14px;
        height: 14px;
    }

    .baloa-play-payment-options-modal .modal__container {
        padding: 33px 12px 8px 12px;
        margin: 0;
        width: 100%;
        border-radius: 13px 13px 0px 0px;
    }

    .baloa-play-payment-options-modal__title {
        font-size: 16px;
    }

    .baloa-play-payment-options-modal__message {
        font-size: 14px;
    }

    .baloa-play-payment-options-modal__comparative-title {
        font-size: 14px;
    }
    .baloa-play-payment-options-modal__comparative-title .option {
        padding: 0;
    }

    .baloa-play-payment-options-modal__message-container .hubicon-award_star {
        font-size: 20px;
    }

    .baloa-play-payment-options-modal__comparative-char {
        font-size: 13px;
    }

    .baloa-play-payment-options-modal__comparative-char .option {
        padding: 0;
    }

    .baloa-play-payment-options-modal__comparative-char .mark .hubicon-clear_option {
        font-size: 22px;
    }

    .baloa-play-payment-options-modal__comparative-char .mark .hubicon-check {
        font-size: 22px;
    }
    
    .baloa-play-payment-options-modal__message-container .primary-button.button {
        font-size: 15px;
    }

    .baloa-play-payment-options-modal__container .button {
        margin-top: 14px;
        margin-bottom: 14px;
        font-size: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-play/components/baloa-play-payment-options-modal-component/BaloaPlayPaymentOptionsModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,+BAA+B;IAC/B,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;;;GAMG;;AAEH;IACI,0BAA0B;IAC1B,eAAe;IACf,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,eAAe;IACf,sDAAsD;IACtD,yDAAyD;IACzD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gCAAgC;IAChC,qCAAqC;IACrC,eAAe;IACf,yDAAyD;IACzD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,SAAS;QACT,WAAW;QACX,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;IACnB;AACJ","sourcesContent":["\n.baloa-play-payment-options-modal .modal__container {\n    width: 715px;\n    padding: 55px 44px 24px 44px;\n}   \n\n.baloa-play-payment-options-modal__container {\n    text-align: center;\n}\n\n.baloa-play-payment-options-modal .modal__container__close {\n    right: 20px;\n    top: 14px;\n}\n\n.baloa-play-payment-options-modal .modal__container__close img {\n    width: 16px;\n    height: 16px;\n}\n\n.baloa-play-payment-options-modal__title {\n    font-family: \"Lexend Deca\";\n    font-size: 20px;\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n    margin-top: 6px;\n}\n\n.baloa-play-payment-options-modal__message-container {\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    margin-top: 0;\n}\n\n.baloa-play-payment-options-modal__message-container .hubicon-award_star {\n    font-size: 24px;\n}\n\n/* .baloa-play-payment-options-modal__subtitle {\n    font-family: \"Lexend Deca\";\n    font-size: 18px;\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n    margin-top: 6px;\n} */\n\n.baloa-play-payment-options-modal__message {\n    font-family: \"Lexend Deca\";\n    font-size: 17px;\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n    margin-top: 14px;\n}\n\n.baloa-play-payment-options-modal__message-container .primary-button.button {\n    width: 100%;\n    margin-top: 10px;\n    font-size: 18px;\n    text-transform: unset;\n    font-family: \"Lexend Deca\";\n}\n\n.baloa-play-payment-options-modal__message-container .primary-button.button span {\n    text-transform: unset;\n}\n\n.baloa-play-payment-options-modal__container .button {\n    width: 100%;\n    padding: 12px;\n    margin-top: 36px;\n    text-transform: unset;\n    font-size: 18px;\n}\n\n.baloa-play-payment-options-modal__container .button.primary-button {\n    margin-top: 10px;\n}\n\n.baloa-play-payment-options-modal__container .secondary-button.button span {\n    text-transform: unset;\n}\n\n.baloa-play-payment-options-modal__comparative-title {\n    font-family: \"Lexend Deca\";\n    font-size: 18px;\n    margin-top: 14px;\n    font-weight: var(--font-medium);\n    color: var(--black-color);\n    padding: 10px 0;\n    border-top: 1px solid var(--new-gray-background-color);\n    border-bottom: 1px solid var(--new-gray-background-color);\n    display: flex;\n    align-items: center;\n}\n\n.baloa-play-payment-options-modal__comparative-title .option {\n    padding: 10px;\n    text-align: left;\n    width: 60%;\n}\n\n.baloa-play-payment-options-modal__comparative-title .no-pro {\n    padding: 10px 0;\n    text-align: center;\n    font-weight: var(--font-regular);\n    width: 20%;\n}\n\n.baloa-play-payment-options-modal__comparative-title .pro {\n    padding: 10px 0;\n    justify-content: center;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    width: 20%;\n}\n\n.baloa-play-payment-options-modal__comparative-char {\n    font-family: \"Lexend Deca\";\n    font-size: 16px;\n    font-weight: var(--font-regular);\n    color: var(--primary-very-dark-color);\n    padding: 11px 0;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    display: flex;\n    align-items: center;\n}\n\n.baloa-play-payment-options-modal__comparative-char:last-child {\n    border-bottom: none;\n}\n\n.baloa-play-payment-options-modal__comparative-char .option {\n    padding: 10px;\n    text-align: left;\n    width: 60%;\n}\n\n.baloa-play-payment-options-modal__comparative-char .mark {\n    padding: 10px 0;\n    text-align: center;\n    width: 20%;\n}\n\n.baloa-play-payment-options-modal__comparative-char .mark .hubicon-clear_option {\n    color: var(--error-color);\n    font-size: 24px;\n}\n\n.baloa-play-payment-options-modal__comparative-char .mark .hubicon-check {\n    color: var(--new-green-color);\n    font-size: 24px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .baloa-play-payment-options-modal.modal {\n        top: unset;\n    }\n\n    .baloa-play-payment-options-modal .modal__container__close {\n        right: 12px;\n    }\n\n    .baloa-play-payment-options-modal .modal__container__close img {\n        width: 14px;\n        height: 14px;\n    }\n\n    .baloa-play-payment-options-modal .modal__container {\n        padding: 33px 12px 8px 12px;\n        margin: 0;\n        width: 100%;\n        border-radius: 13px 13px 0px 0px;\n    }\n\n    .baloa-play-payment-options-modal__title {\n        font-size: 16px;\n    }\n\n    .baloa-play-payment-options-modal__message {\n        font-size: 14px;\n    }\n\n    .baloa-play-payment-options-modal__comparative-title {\n        font-size: 14px;\n    }\n    .baloa-play-payment-options-modal__comparative-title .option {\n        padding: 0;\n    }\n\n    .baloa-play-payment-options-modal__message-container .hubicon-award_star {\n        font-size: 20px;\n    }\n\n    .baloa-play-payment-options-modal__comparative-char {\n        font-size: 13px;\n    }\n\n    .baloa-play-payment-options-modal__comparative-char .option {\n        padding: 0;\n    }\n\n    .baloa-play-payment-options-modal__comparative-char .mark .hubicon-clear_option {\n        font-size: 22px;\n    }\n\n    .baloa-play-payment-options-modal__comparative-char .mark .hubicon-check {\n        font-size: 22px;\n    }\n    \n    .baloa-play-payment-options-modal__message-container .primary-button.button {\n        font-size: 15px;\n    }\n\n    .baloa-play-payment-options-modal__container .button {\n        margin-top: 14px;\n        margin-bottom: 14px;\n        font-size: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
